


import React, { useState } from 'react';
import { ChartColumnIncreasing, CreditCard, Landmark } from 'lucide-react';
import FinanceStats from './FinanceStats';
import TransactionView from './TransactionView';
import PaymentGatewaySettlement from './PaymentGatewaySettlement';
import '../style/financeDashboard.css';

// Plain-language labels + one-line explainer for each tab so a first-time
// owner knows what they're about to look at before they tap it.
const TABS = [
  {
    key: 'stats',
    label: 'Sales & Trends',
    hint: 'Revenue, orders and top-selling items',
    Icon: ChartColumnIncreasing,
    Component: FinanceStats,
  },
  {
    key: 'txns',
    label: 'Payments',
    hint: 'Every order payment, searchable',
    Icon: CreditCard,
    Component: TransactionView,
  },
  {
    key: 'settlement',
    label: 'Bank Settlement',
    hint: 'Money credited to your account',
    Icon: Landmark,
    Component: PaymentGatewaySettlement,
  },
];

const FinanceDashboard = ({ cafeid }) => {
  const [activeTab, setActiveTab] = useState('stats');
  const active = TABS.find((t) => t.key === activeTab) ?? TABS[0];
  const ActiveComponent = active.Component;

  return (
    <div className="fd-shell">
      {/* ── Tab bar ── */}
      <nav className="fd-tabbar" aria-label="Finance sections">
        <div className="fd-tabbar-scroll">
          {TABS.map((t) => {
            const isActive = activeTab === t.key;
            return (
              <button
                key={t.key}
                type="button"
                className={`fd-tab ${isActive ? 'fd-tab--active' : ''}`}
                onClick={() => setActiveTab(t.key)}
                aria-current={isActive ? 'page' : undefined}
              >
                <span className="fd-tab-icon">
                  <t.Icon size={20} strokeWidth={2} />
                </span>
                <span className="fd-tab-copy">
                  <span className="fd-tab-label">{t.label}</span>
                  <span className="fd-tab-hint">{t.hint}</span>
                </span>
              </button>
            );
          })}
        </div>
      </nav>

      {/* ── Active section ── */}
      <div className="fd-content">
        {ActiveComponent && <ActiveComponent cafeid={cafeid} />}
      </div>
    </div>
  );
};

export default FinanceDashboard;